export const visit = (vm, at) => {
at({ "en": { "profileCommunicatorContainer": { "draggableOnboardingPopover": { "body": "Compose activity from anywhere on the record by dragging this top bar.", "buttonText": "Got it", "title": "Drag and drop" } } } });
};